import R from 'ramda'
import moment from 'moment'
import { combineReducers } from 'redux'
import { fromNullable } from 'data.maybe'
import {
  SET_UNIT_GROUP_FILTER,
  SET_SELECTED_GROUPS,
  SET_SELECTED_UNITS,
} from 'analytics/action-names'

import {
  CHANGE_PERIOD,
  SET_LOADING,
  // STORE_SUM_DATA,
  STORE_DETAIL_DATA,
  STORE_EFORD_CONTRIB,
  STORE_AG_EFORD,
  STORE_KPI_SPEC,
  STORE_KPI_AG,
  STORE_KPI_CA_AG,
  STORE_KPI_CONTRIB,
  STORE_KPI_CA_CONTRIB,
  STORE_CONTRIB_KEYS,
  STORE_CA_CONTRIB_KEYS,
  STORE_KPI_GOALS,
  STORE_YEAR,
  STORE_CA_DATA,
  STORE_WEEK_HOUR_DATA,
  SET_SHOW_SELECTOR,
  STORE_GADS_MONTHLY_DATA,
  STORE_GADS_SUMMARIZED_DATA,
  STORE_PNL_WEEKLY_DATA,
} from './action-names'

// import { summarizeData } from './utils'

// const to = moment()
// const from = moment().add(-11, 'month')

const defPeriod = {
  from: { year: new Date().getFullYear() - 1, month: 1 },
  to: { year: new Date().getFullYear() - 1, month: 12 },
}

const period = (state = defPeriod, action) => {
  switch (action.type) {
    case CHANGE_PERIOD:
      return action.payload
  }
  return state
}

const loading = (state = false, action) => {
  switch (action.type) {
    case SET_LOADING:
      return action.payload
  }
  return state
}

const summaryData = (state = [], action) => {
  switch (action.type) {
    case STORE_DETAIL_DATA: {
      const { summaryData /* rollupMap, data */ } = action.payload
      // return summarizeData(rollupMap)(data)
      return summaryData
    }
    case SET_UNIT_GROUP_FILTER:
    case SET_SELECTED_UNITS:
    case SET_SELECTED_GROUPS:
      return []
  }
  return state
}

const agEford = (state = {}, action) => {
  switch (action.type) {
    case STORE_AG_EFORD: {
      const ag = action.payload
      const { monthly } = ag
      const normalizeMonthly = R.compose(
        R.map(({ date, EFORD }) => ({ date: date.format('YYYY-MMM'), EFORD })),
        R.sort((a, b) => a.date.toDate().getTime() - b.date.toDate().getTime()),
        R.map(([date, EFORD]) => ({ date: moment(date), EFORD })),
        R.toPairs
      )
      return { ...ag, monthly: normalizeMonthly(monthly) }
    }
    case SET_UNIT_GROUP_FILTER:
    case SET_SELECTED_UNITS:
    case SET_SELECTED_GROUPS:
    case CHANGE_PERIOD:
      return []
  }
  return state
}

const processAg = ag => {
  const { monthly } = ag
  const normalizeMonthly = R.compose(
    R.map(({ date, value }) => ({ date: date.format('YYYY-MMM'), value })),
    R.sort((a, b) => a.date.toDate().getTime() - b.date.toDate().getTime()),
    R.map(([date, value]) => ({ date: moment(date), value })),
    R.toPairs
  )
  return { ...ag, monthly: normalizeMonthly(monthly) }
}

const kpiAg = (state = {}, action) => {
  switch (action.type) {
    case STORE_KPI_AG: {
      const process = R.compose(
        R.fromPairs,
        R.map(([key, data]) => [key, processAg(data)]),
        R.toPairs
      )
      return process(action.payload)
    }
    case SET_UNIT_GROUP_FILTER:
    case SET_SELECTED_UNITS:
    case SET_SELECTED_GROUPS:
    case CHANGE_PERIOD:
      return {}
  }
  return state
}

const kpiCAAg = (state = {}, action) => {
  switch (action.type) {
    case STORE_KPI_CA_AG: {
      const process = R.compose(
        R.fromPairs,
        R.map(([key, data]) => [key, processAg(data)]),
        R.toPairs
      )
      return process(action.payload)
    }
    case SET_UNIT_GROUP_FILTER:
    case SET_SELECTED_UNITS:
    case SET_SELECTED_GROUPS:
    case CHANGE_PERIOD:
      return {}
  }
  return state
}

const kpiSpec = (state = [], action) => {
  switch (action.type) {
    case STORE_KPI_SPEC:
      return action.payload
  }
  return state
}

const processSpec = R.compose(
  R.fromPairs,
  R.map(m => [m.id, m]),
  R.chain(group => group.metrics.map(m => ({ ...m, group })))
)

const metrics = (state = {}, action) => {
  switch (action.type) {
    case STORE_KPI_SPEC:
      return processSpec(action.payload)
  }
  return state
}

const contribKeys = (state = [], action) => {
  switch (action.type) {
    case STORE_CONTRIB_KEYS:
      return action.payload
  }
  return state
}

const caContribKeys = (state = [], action) => {
  switch (action.type) {
    case STORE_CA_CONTRIB_KEYS:
      return action.payload
  }
  return state
}

function combineCompare() {
  for (let i = 0; i < arguments.length; i++) {
    const res = arguments[i]()
    if (res !== 0) return res
  }
  return 0
}

const goals = (state = [], action) => {
  switch (action.type) {
    case STORE_KPI_GOALS: {
      const { data, unitMap, kpiMap } = action.payload

      const getDisplay = map => key =>
        fromNullable(map)
          .chain(m => fromNullable(m[key]))
          .getOrElse(key)

      const getUnitName = getDisplay(unitMap)
      const getKpiName = getDisplay(kpiMap)

      return fromNullable(data)
        .map(d =>
          R.sort(
            (a, b) =>
              combineCompare(
                () => getUnitName(a.unitId).localeCompare(getUnitName(b.unitId)),
                () => getKpiName(a.kpi).localeCompare(getKpiName(b.kpi))
              ),
            d
          )
        )
        .getOrElse(0)
    }
  }
  return state
}

const year = (state = new Date().getFullYear(), action) => {
  switch (action.type) {
    case STORE_YEAR:
      return action.payload
  }
  return state
}
// unitId(pin): "944532"
// actualGen(pin): 81620.29
// actualRevenue(pin): 2688164.0434
// actualMargin(pin): 249399.23693333333
// lostMwh(pin): 7295.8
// lostRevenue(pin): 331401.023
// lostMargin(pin): 90628.3
// targetRevenue(pin): 3903318.48
// totalCost(pin): 2734133.8701
// unavailMwCost(pin): 241758.49266666666

const retrievedReducer = ({ actionName, defaultState = [] }) => (state = defaultState, action) => {
  switch (action.type) {
    case actionName:
      return action.payload
    case SET_UNIT_GROUP_FILTER:
    case SET_SELECTED_UNITS:
    case SET_SELECTED_GROUPS:
    case CHANGE_PERIOD:
    case STORE_YEAR:
      return defaultState
  }
  return state
}

const showSelector = (state = true, action) => {
  switch (action.type) {
    case STORE_DETAIL_DATA:
      return false
    case SET_SHOW_SELECTOR:
      return action.payload
  }
  return state
}

const detailData = (state = [], action) => {
  switch (action.type) {
    case STORE_DETAIL_DATA:
      return action.payload.data
  }
  return state
}

export default combineReducers({
  period,
  loading,
  summaryData,
  detailData, // : retrievedReducer({ actionName: STORE_DETAIL_DATA }),
  efordContrib: retrievedReducer({ actionName: STORE_EFORD_CONTRIB }),
  agEford,
  kpiSpec,
  kpiContrib: retrievedReducer({
    actionName: STORE_KPI_CONTRIB,
    defaultState: {},
  }),
  kpiCAContrib: retrievedReducer({
    actionName: STORE_KPI_CA_CONTRIB,
    defaultState: {},
  }),
  kpiAg,
  kpiCAAg,
  contribKeys,
  caContribKeys,
  goals,
  year,
  caData: retrievedReducer({ actionName: STORE_CA_DATA }),
  weekHourData: retrievedReducer({
    actionName: STORE_WEEK_HOUR_DATA,
  }),
  showSelector,
  gadsSummarizedData: retrievedReducer({
    actionName: STORE_GADS_SUMMARIZED_DATA,
  }),
  gadsMonthlyData: retrievedReducer({
    actionName: STORE_GADS_MONTHLY_DATA,
  }),
  pnlWeeklyData: retrievedReducer({
    actionName: STORE_PNL_WEEKLY_DATA,
  }),
  metrics,
})
